import { FunctionComponent } from "react"
import { Alert, Col, Container, Row } from "react-bootstrap"
import Button from "react-bootstrap/Button"
import { useNavigate, useParams } from "react-router-dom"
import { RouterExtended } from "../data/models"
import useLazyQuery from "../hooks/useLazyQuery"
import useQuery from "../hooks/useQuery"
import StringUtils from "../utils/StringUtils"

interface IChangePasswordPage {}
const ChangePasswordPage: FunctionComponent<IChangePasswordPage> = () => {
	const navigate = useNavigate()
	const params = useParams()
	const routerId = params.routerId
	const routerQuery = useQuery<void, RouterQueryResponse>(`${process.env.REACT_APP_KNIT_URL}routers?id=${routerId}`)
	const router = routerQuery.data?.routers?.[0]
	const changeUrl = `${process.env.REACT_APP_KNIT_URL}routers/${routerId}/change-unit-wifi-password`
	const changePasswordQuery = useLazyQuery<ChangePasswordInput, any>(changeUrl, "PATCH")
	//change password function
	const changePassword = async () => {
		await changePasswordQuery.query({
			body: {
				password: StringUtils.random(12, "abcdefghijkmnpqrstuvwxyz23456789"),
			},
		})
		navigate(-1)
	}
	//
	const error = changePasswordQuery.error || routerQuery.error
	//
	if (!routerQuery.data) {
		return (
			<Container style={{ maxWidth: 800 }}>
				<h2 className="text-center mt-4">Change WIFI Password</h2>
				<div className="text-center">Loading</div>
			</Container>
		)
	}
	return (
		<Container style={{ maxWidth: 800 }}>
			<h2 className="text-center mt-4">
				Change WIFI Password for {router?.propertyName} {router?.unitName}
			</h2>
			{error && <Alert variant={"warning"}>{error}</Alert>}
			<div className="text-center">This will replace the current WIFI password with a new randomly generated password.</div>
			<Row className="mt-4">
				<Col xs="auto">
					<Button variant="secondary" disabled={changePasswordQuery.loading} onClick={() => navigate(-1)}>
						Cancel
					</Button>
				</Col>
				<Col></Col>
				<Col xs="auto">
					<Button variant="primary" disabled={changePasswordQuery.loading || !!error} onClick={changePassword}>
						{changePasswordQuery.loading ? "Changing" : "Change"}
					</Button>
				</Col>
			</Row>
		</Container>
	)
}

export default ChangePasswordPage

interface ChangePasswordInput {
	password: string
}
interface RouterQueryResponse {
	routers: RouterExtended[]
}
